import {
    Show as ChakraShow, Hide as ChakraHide, HideProps, ShowProps,
} from '@chakra-ui/react';

function Show(props: Omit<ShowProps, 'ssr' | 'below'>) {
    return <ChakraShow {...props} ssr={false} />;
}

function Hide(props: Omit<HideProps, 'ssr' | 'below'>) {
    return <ChakraHide {...props} ssr={false} />;
}

export { Show, Hide };
